import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { AfectacionesCompraConstant } from 'constants/index'

const DefectoAfectacionComprasFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DEF AFECT COMPRAS' htmlFor='select-defectoAfectacionCompras' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='defectoAfectacionCompras'>
          {({ field }) => (
            <Form.Select {...field} id='select-defectoAfectacionCompras' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              {AfectacionesCompraConstant.__array.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DefectoAfectacionComprasFormGroup)
